import React, { useState } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { Snackbar, Alert, ThemeProvider,CssBaseline,createTheme } from '@mui/material'
import Login from './components/auth/login'
import Register from './components/auth/register'
import ForgotPassword from './components/auth/forgotpassword'
import Dashboard from './components/dashboard'
import CreateEditJob from './components/createeditJob'
import Notifications from './components/notification'
import Chatting from './components/chat'
import Settings from './components/settings'
import Analysis from './components/analysis'
import Layout from '../src/common/layout'
import ProtectedRoute from './common/protectedroute'
import AnalyticsPage from './components/proposal'
import usePusher from './hook/pusher.js' // Import your usePusher hook

// Create a wrapper component that uses Pusher
function ProtectedWithPusher({ children, showSnackbar }) {
  usePusher(); // Initialize Pusher
  return children;
}

const theme = createTheme({
  typography: {
    fontFamily: 'Montserrat, Arial, sans-serif',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          scrollBehavior: "smooth",   // global smooth scroll
        },
      },
    },
  },
})

function App() {
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  const showSnackbar = (message, severity = "success") => {
    setSnackbar({
      open: true,
      message,
      severity,
    });
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
     <ThemeProvider theme={theme}>
      <CssBaseline />
    <Router>
        <Routes>
          <Route 
            path="/login" 
            element={<Login showSnackbar={showSnackbar} />}
          />
          <Route 
            path="/register" 
            element={<Register showSnackbar={showSnackbar} />}
          />
          <Route 
            path="/forgot-password" 
            element={<ForgotPassword showSnackbar={showSnackbar} />}
          />
          
          {/* Protected routes with Pusher */}
          <Route element={<ProtectedRoute />}>
            <Route 
              path="/" 
              element={
                <ProtectedWithPusher showSnackbar={showSnackbar}>
                  <Layout showSnackbar={showSnackbar}>
                    <Dashboard />
                  </Layout>
                </ProtectedWithPusher>
              } 
            />
            <Route 
              path="/dashboard" 
              element={
                <ProtectedWithPusher showSnackbar={showSnackbar}>
                  <Layout showSnackbar={showSnackbar}>
                    <Dashboard />
                  </Layout>
                </ProtectedWithPusher>
              } 
            />
            <Route 
              path="/create-job" 
              element={
                <ProtectedWithPusher showSnackbar={showSnackbar}>
                  <Layout showSnackbar={showSnackbar}>
                    <CreateEditJob showSnackbar={showSnackbar} />
                  </Layout>
                </ProtectedWithPusher>
              } 
            />
            <Route 
              path="/proposals/:job_guid" 
              element={
                <ProtectedWithPusher showSnackbar={showSnackbar}>
                  <Layout showSnackbar={showSnackbar}>
                    <AnalyticsPage showSnackbar={showSnackbar} />
                  </Layout>
                </ProtectedWithPusher>
              } 
            />
            <Route 
              path="/edit-job/:id" 
              element={
                <ProtectedWithPusher showSnackbar={showSnackbar}>
                  <Layout showSnackbar={showSnackbar}>
                    <CreateEditJob showSnackbar={showSnackbar} />
                  </Layout>
                </ProtectedWithPusher>
              } 
            />
            <Route 
              path="/notifications" 
              element={
                <ProtectedWithPusher showSnackbar={showSnackbar}>
                  <Layout showSnackbar={showSnackbar}>
                    <Notifications />
                  </Layout>
                </ProtectedWithPusher>
              } 
            />
            <Route 
              path="/chat" 
              element={
                <ProtectedWithPusher showSnackbar={showSnackbar}>
                  <Layout showSnackbar={showSnackbar}>
                    <Chatting />
                  </Layout>
                </ProtectedWithPusher>
              } 
            />
            <Route 
              path="/settings" 
              element={
                <ProtectedWithPusher showSnackbar={showSnackbar}>
                  <Layout showSnackbar={showSnackbar}>
                    <Settings showSnackbar={showSnackbar} />
                  </Layout>
                </ProtectedWithPusher>
              } 
            />
            <Route 
              path="/analysis" 
              element={
                <ProtectedWithPusher showSnackbar={showSnackbar}>
                  <Layout showSnackbar={showSnackbar}>
                    <Analysis />
                  </Layout>
                </ProtectedWithPusher>
              } 
            />
          </Route>
        </Routes>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={6000}
          onClose={handleCloseSnackbar}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          style={{ marginTop: "60px" }}
        >
          <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>
            {snackbar.message}
          </Alert>
        </Snackbar>
    </Router>
        </ThemeProvider>

  );
}

export default App;